import React, { useState } from 'react';

const ModernHeader = ({ 
  tabs, 
  activeTab, 
  setActiveTab, 
  user, 
  profileData, 
  isAdmin, 
  handleLogout 
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  //Gradientes para avatar
  const gradients = [
    { colors: ['#667eea', '#764ba2'], textColor: 'text-white' },
    { colors: ['#f093fb', '#f5576c'], textColor: 'text-white' },
    { colors: ['#4facfe', '#00f2fe'], textColor: 'text-white' },
    { colors: ['#43e97b', '#38f9d7'], textColor: 'text-gray-800' },
    { colors: ['#fa709a', '#fee140'], textColor: 'text-gray-800' },
    { colors: ['#30cfd0', '#330867'], textColor: 'text-white' },
    { colors: ['#a8edea', '#fed6e3'], textColor: 'text-gray-800' },
    { colors: ['#ff9a9e', '#fecfef'], textColor: 'text-gray-800' },
    { colors: ['#ffecd2', '#fcb69f'], textColor: 'text-gray-800' },
    { colors: ['#ff6e7f', '#bfe9ff'], textColor: 'text-gray-800' },
  ];

  const gradientIndex = (profileData?.nome_completo || user?.email || 'U').charCodeAt(0) % 10;
  const selectedGradient = gradients[gradientIndex];

  const getTabActiveClass = (theme) => {
    const themeClasses = {
      'blue': 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg',
      'green': 'bg-gradient-to-r from-green-500 to-green-600 text-white shadow-lg',
      'amber': 'bg-gradient-to-r from-amber-500 to-amber-600 text-white shadow-lg',
      'purple': 'bg-gradient-to-r from-purple-500 to-purple-600 text-white shadow-lg'
    };
    return themeClasses[theme] || themeClasses['blue'];
  };

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setMobileMenuOpen(false);
  };

  return (
    <header className="bg-white/95 backdrop-blur-md shadow-lg sticky top-0 z-50 border-b border-gray-200">
      <div className="container mx-auto px-4 lg:px-6">
        <div className="flex items-center justify-between h-16 lg:h-20">
          
          <div className="flex items-center gap-3 flex-shrink-0">
            <div className="w-10 h-10 lg:w-12 lg:h-12 bg-gradient-to-br from-blue-500 via-indigo-600 to-purple-600 rounded-2xl flex items-center justify-center text-white font-bold text-lg lg:text-xl shadow-lg transform hover:scale-105 transition-transform">
              VT
            </div>
            <div className="flex flex-col">
              <h1 className="text-xl lg:text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                VisãoTISS
              </h1>
              <p className="text-xs text-gray-500 hidden sm:block">Análise de Arquivos TISS</p>
            </div>
          </div>

          <nav className="hidden lg:flex items-center gap-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={`
                  group relative px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-300
                  ${activeTab === tab.id
                    ? getTabActiveClass(tab.theme)
                    : "bg-gray-50 text-gray-600 hover:bg-gray-100 hover:shadow-md"
                  }
                `}
              >
                <span className="flex items-center gap-2">
                  <span className="text-base">{tab.icon}</span>
                  <span className="hidden xl:inline">{tab.name}</span>
                </span>
                {activeTab === tab.id && (
                  <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-white rounded-t-full"></div>
                )}
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            {user && (
              <div className="relative">
                <button
                  onClick={() => setUserMenuOpen(!userMenuOpen)}
                  className="flex items-center gap-3 hover:bg-gray-50 rounded-xl px-3 py-2 transition-all duration-200"
                >
                  <div 
                    className={`w-10 h-10 rounded-full flex items-center justify-center ${selectedGradient.textColor} font-semibold shadow-md ring-2 ring-white`}
                    style={{
                      background: `linear-gradient(135deg, ${selectedGradient.colors.join(', ')})`
                    }}
                  >
                    {(profileData?.nome_completo || user.email || 'U').charAt(0).toUpperCase()}
                  </div>
                  
                  <div className="text-left">
                    <p className="font-semibold text-gray-800 text-sm">
                      {profileData?.nome_completo || user.email}
                    </p>
                    <p className="text-xs text-gray-500 flex items-center gap-1">
                      {isAdmin ? (
                        <>
                          <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                          </svg>
                          Administrador
                        </>
                      ) : "Usuário"}
                      {profileData?.companies && (
                        <span className="ml-1">• {profileData.companies.nome_fantasia}</span>
                      )}
                    </p>
                  </div>
                  
                  <svg 
                    className={`w-4 h-4 text-gray-400 transition-transform ${userMenuOpen ? 'rotate-180' : ''}`} 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                {userMenuOpen && (
                  <>
                    <div 
                      className="fixed inset-0 z-10" 
                      onClick={() => setUserMenuOpen(false)}
                    ></div>
                    <div className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-2xl border border-gray-100 py-2 z-20">
                      <div className="px-4 py-3 border-b border-gray-100">
                        <p className="font-semibold text-gray-800">{profileData?.nome_completo || user.email}</p>
                        <p className="text-sm text-gray-500">{user.email}</p>
                        {profileData?.companies && (
                          <div className="mt-2 px-2 py-1 bg-blue-50 rounded text-xs text-blue-600">
                            {profileData.companies.razao_social}
                          </div>
                        )}
                      </div>
                      
                      <button
                        onClick={handleLogout}
                        className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors flex items-center gap-2"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                        Sair
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>

          {/* Mobile */}
          <div className="flex lg:hidden items-center gap-3">
            {user && (
              <div 
                className={`w-9 h-9 rounded-full flex items-center justify-center ${selectedGradient.textColor} font-semibold text-sm shadow-md`}
                style={{
                  background: `linear-gradient(135deg, ${selectedGradient.colors.join(', ')})`
                }}
              >
                {(profileData?.nome_completo || user.email || 'U').charAt(0).toUpperCase()}
              </div>
            )}
            
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
              aria-label="Menu"
            >
              <svg 
                className="w-6 h-6 text-gray-700" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-gray-100 py-4 animate-slideDown">
       
            <nav className="flex flex-col gap-2 mb-4">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={`
                    px-4 py-3 rounded-lg text-left font-medium transition-all duration-200
                    ${activeTab === tab.id
                      ? getTabActiveClass(tab.theme)
                      : "bg-gray-50 text-gray-700 hover:bg-gray-100"
                    }
                  `}
                >
                  <span className="flex items-center gap-3">
                    <span className="text-lg">{tab.icon}</span>
                    <span>{tab.name}</span>
                  </span>
                </button>
              ))}
            </nav>

            {user && (
              <div className="border-t border-gray-100 pt-4">
                <div className="px-4 py-3 bg-gray-50 rounded-lg mb-2">
                  <p className="font-semibold text-gray-800">{profileData?.nome_completo || user.email}</p>
                  <p className="text-sm text-gray-500 mt-1">
                    {isAdmin ? "🛡️ Administrador" : "👤 Usuário"}
                  </p>
                  {profileData?.companies && (
                    <p className="text-xs text-gray-600 mt-2 px-2 py-1 bg-white rounded">
                      {profileData.companies.nome_fantasia || profileData.companies.razao_social}
                    </p>
                  )}
                </div>
                <button
                  onClick={handleLogout}
                  className="w-full px-4 py-3 text-red-600 font-medium bg-red-50 rounded-lg hover:bg-red-100 transition-colors flex items-center justify-center gap-2"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  Sair
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slideDown {
          animation: slideDown 0.2s ease-out;
        }
      `}</style>
    </header>
  );
};

export default ModernHeader;
